import React from "react";
import { LoaderImg } from '../../assets/svg'
import { laoderWrap } from "./loader.module.css";

const Loader = () => {
  return (
    <div className={laoderWrap}>
        <LoaderImg />
    </div>
  ); 
};

export { Loader }